/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendDiscountRateDto } from '../../models/backend-discount-rate-dto';
import { BackendDiscountRateRequestDto } from '../../models/backend-discount-rate-request-dto';

export interface ProjectTaxesDiscountRatesCreate$FormData$Params {
  body: BackendDiscountRateRequestDto;
}

export function projectTaxesDiscountRatesCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesDiscountRatesCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesDiscountRatesCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendDiscountRateDto>;
    }),
  );
}

projectTaxesDiscountRatesCreate$FormData.PATH = '/api/project_taxes/discount_rates/';
